import React, { useCallback, useMemo, useState } from "react";
import styles3 from "../../styles/components/partnerCard.module.scss";
import styles from "../../styles/pages/memberEditors.module.scss";
import styles1 from "../../styles/components/partnerSubmissionFeeModal.module.scss";
import styles2 from "../../styles/pages/home.module.scss";
import styles4 from "../../styles/pages/analyticseditor.module.scss";

import {
  Avatar,
  Box,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  MenuItem,
  Paper,
  SelectChangeEvent,
  Slide,
  Stack,
  Tab,
  Tabs,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
// import Image from "next/image";
import assest from "../../json/assest";
import PartnerListItem from "../PartnerListItem/PartnerListItem";
// import { TransitionProps } from "@mui/material/transitions";
import EditorsLargeModal from "../../ui/Modal/EditorsLargeModal";
// import { submissionsList } from "../../api/functions/cms.api";
import AccountingIcon from "../../ui/Icons/AccountingIcon";
import AnalyticsIcon from "../../ui/Icons/AnalyticsIcon";
import HomeIcon from "../../ui/Icons/HomeIcon";
import ProfileIcon from "../../ui/Icons/ProfileIcon";
import VideoIcon from "../../ui/Icons/VideoIcon";
// import ModalWrapperBonus from "../../ui/ModalWrapper/ModalWrapperBonus";
// import dynamic from "next/dynamic";
// import { useRouter } from "next/router";
// import { useQuery } from "react-query";
import AnalyticsBreakdown from "../AnalyticsBreakdown/AnalyticsBreakdown";
import BonusModal from "../BonusModal/BonusModal";
import BuyerAccounting from "../BuyerAccounting/BuyerAccounting";
import CustomSelectTwo from "../CustomSelectTwo/CustomSelectTwo";
import VideosummaryCard from "../VideosummaryCard/VideosummaryCard";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import PartnerPageTable from "../AllTable/PartnerPageTables/PartnerPageTable";
import BuyerPageTable from "../AllTable/BuyerPageTables/BuyerPageTable";
import MemberPageTable from "../AllTable/MemberPageTables/MemberPageTable";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import ProfileTabPartner from "../EditorsCopywritersProfileTab/ProfileTabPartner";
import ProfileTabMember from "../EditorsCopywritersProfileTab/ProfileTabMember";
import ProfileTabBuyerList from "../EditorsCopywritersProfileTab/ProfileTabBuyerList";
import useFetch, { usePost } from "../../hooks/api/useFetch";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import {
  concatHostAndImagePath,
  getAbsoluteImageURI,
  getMonthQueryRange,
  getMonthRange,
  getStyledDateTime,
  getStyledShortDate,
  getUtcDateTime,
  getYearRange,
} from "../../lib/functions/utils.lib";
import ModalWrapperBonus from "../../ui/Modal/ModalWrapper/ModalWrapperBonus";

// interface breadprops {
//     user_id: number | string | "0";
//     image ;
//     cardName: string;
//     cardLink: string;
//     cardTime: string;
//     cardTextspan1: string;
//     cardTextspan2: string;
//     cardTextspan3: string;
//     cardtext1: string;
//     cardtext2: string;
//     cardtext3: string;
//     buttonName: string;
//     accountSubmission: boolean;
//     classProps: "true";
//     cardProp: string;
//     cardVideoCount: number;
//     cardVideoApprovedCount: number;
//     cardVideoRejectedCount: number;
//     cardVideoDuplicateCount: number;
// }

// new

// const ReactApexChart = dynamic(() => import("react-apexcharts"), {
//   ssr: false,
// });

import ReactApexChart from "react-apexcharts";
import ContentBuyerListItem from "../ContentBuyerListItem/ContentBuyerListItem";
import ContentBuyerAnalyticsBreakdown from "../AnalyticsBreakdown/ContentBuyerAnalyticsBreakdown";
import ModalWrappperLargeOpacity from "../../ui/ModalWrapper/ModalWrapperLargeOpacity";
import axiosInstance from "../../api/axiosInstance";
import useNotiStack from "../../hooks/useNotistack";
import SelectMonth from "../SelectMonth/SelectMonth";
import SelectYear from "../SelectYear/SelectYear";
import ContentBuyerGraph from "../ContentBuyerGraph/ContentBuyerGraph";
import NOprofileImage from "../../public/assets/images/no-image.svg";
import { useEffect } from "react";
import VideosummaryCardPartner from "../VideosummaryCard/VideosummaryCardPartner";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// for select

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}
// interface Imodalinterface {
//     [x: string] ;
//     accountSubmission ;
//     classProps: "true";
// }

// interface SingleTableContainerProps {
//     // Existing properties...
//     // Add the following line to include emptyTableText property
//     emptyTableText: string;
// }

const schema = yup.object({
  amount: yup
    .number()
    .typeError("Amount  is required ")
    .required("Amount is required")
    .positive("Amount must be a positive number"),
});

const TopAccusitorPartnerCard = (props) => {
  const {
    leftData,
    index,
    user,
    buttonText,
    showAllData,
    topAcqusitiorRefetch,
  } = props;
  const [open, setOpen] = React.useState(false);
  const { toastSuccess, toastError } = useNotiStack();
  // load data

  // load data

  const [openLargeOpacity, setOpenLargeOpacity] = React.useState(false);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setError,
    reset,
    getValues,
  } = useForm({ resolver: yupResolver(schema) });

  const handleClickOpenLargeOpacity = () => {
    setOpenLargeOpacity(true);
  };
  const handleCloseLargeOpacity = () => {
    setOpenLargeOpacity(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [openNewEditorModal, setOpenNewEditorModal] = React.useState(false);

  const handleOpenNewEditorModal = useCallback(() => {
    setOpenNewEditorModal(true);
  }, []);

  const handleCloseNewEditorModal = useCallback(() => {
    setOpenNewEditorModal(false);
  }, []);

  const Transition = React.forwardRef(function Transition(
    props = {
      children,
    },
    ref
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  // new
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);

  const handleChangeyear = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const [status, setStatus] = React.useState("");

  const handleChange1 = (event) => {
    setStatus(event.target.value);
  };

  // modal

  const [openVideoBonus, setOpenVideoBonus] = React.useState(false);
  const handleClickOpenVideoBonus = () => {
    setOpenVideoBonus(true);
  };
  const handleCloseVideoBonus = () => {
    setOpenVideoBonus(false);
  };

  /************/
  const [status1, setStatus1] = React.useState("");
  const searchChange1 = (event) => {
    setStatus1(event.target.value);
  };

  /***************************************/

  const [startDate, setStartDate] = React.useState({
    month: "",
    year: "",
  });
  const handleChildData = (anchorEl) => {
    if (anchorEl.month) {
      setStartDate({ ...startDate, month: anchorEl.month });
    } else if (anchorEl.year) {
      setStartDate({ ...startDate, year: anchorEl.year });
    }
  };

  /***************************************** ContentBuyer Chart section Start*****************************************/

  const [year, setYear] = React.useState(`${new Date().getFullYear()}`);

  const handleChangeYear = (event) => {
    setYear(event.target.value);
  };
  const yearList = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const startingYear = 2021;
    const yearArray = [];

    for (let year = startingYear; year <= currentYear; year++) {
      yearArray.push(year);
    }

    return yearArray;
  }, [new Date().getFullYear()]);

  const { data: contentBuyerGraphData, isLoading: contentBuyerGraphLoading } =
    useFetch(
      ["contentBuyerGraphData", props?.user_id, year],
      `/admin/graph?buyer_id=${
        props?.user_id ? props.user_id : "0"
      }&year=${year}`
    );

  /***************************************** ContentBuyer Chart section End*****************************************/

  /***************************************** ContentBuyer Analytics Bonus section Start*****************************************/

  const [bonusSnackOpen, setBonusSnackOpen] = useState(false);

  const handleConfirmBonus = async (data) => {
    let formData = new FormData();
    formData.append("amount", data?.amount);
    formData.append("user_id", props.user_id);

    await axiosInstance
      .post("admin/add-bonus", formData)
      .then((res) => {
        if (res?.status === 200) {
          //   toastSuccess(res?.data);
          setBonusSnackOpen(true);
          refetchBonusData();
          reset();
        }
      })
      .catch((err) => {
        if (err?.data?.message) {
          toastError(err?.data?.message);
        }
      });
  };
  /***************************************** ContentBuyer Analytics Bonus section End*****************************************/

  const {
    data: submissions,
    isError: submissionsIsError,
    isLoading: submissionsIsLoading,
    isSuccess: submissionsIsSuccess,
    refetch: refetchSubmissions,
  } = usePost(["submissions", props?.user_id, startDate], "admin/submissions", {
    user_id: props?.user_id ? props.user_id : "0",
    from: getMonthQueryRange(startDate?.month, startDate?.year, "obj")
      .from_date,
    to: getMonthQueryRange(startDate?.month, startDate?.year, "obj").to_date,
  });

  const {
    data: VideoSubmissions,
    isError: VideoSubmissionsIsError,
    isLoading: VideoSubmissionsIsLoading,
    isSuccess: VideoSubmissionsIsSuccess,
    refetch: refetchVideoSubmissions,
  } = usePost(["video-submissions", props?.user_id], "admin/submissions", {
    user_id: props?.user_id ? props.user_id : "0",
  });

  const {
    data: contentBuyerSubmissions,
    refetch: contentBuyerSubmissionsRefetch,
  } = usePost(
    [
      "contentBuyerSubmissions",
      props?.user_id,
      startDate?.month,
      startDate?.year,
    ],
    `admin/submissions?buyer_id=${
      props?.user_id ? props?.user_id : "0"
    }&month=${startDate?.month}&year=${startDate?.year}`
  );

  const [earningSummaryYear, setEarningSummaryYear] = useState(
    new Date().getFullYear()
  );

  const {
    data: earnings,
    isError: earningsIsError,
    isLoading: earningsIsLoading,
    isSuccess: earningsIsSuccess,
    refetch: refetchEarnings,
  } = useFetch(
    ["earnings", props?.user_id, earningSummaryYear],
    `/admin/earning-summary-by-month/${earningSummaryYear}?user_id=${
      props?.user_id ? props.user_id : "0"
    }`
  );

  const { data: bonusData, refetch: refetchBonusData } = usePost(
    ["bonusData", props?.user_id],
    `/admin/bonus?user_id=${props?.user_id ? props.user_id : "0"}`
  );

  useEffect(() => {
    refetchSubmissions();
    refetchVideoSubmissions();
    refetchEarnings();
    refetchBonusData();
  }, [openNewEditorModal]);

  return (
    <>
      <Box
        key={index + 1}
        className={styles4.topacquisitorAnalyticBox}
        onClick={handleOpenNewEditorModal}
        style={{ cursor: "pointer" }}
      >
        <Box className={styles4.acquisitorAnalyticBoxNo}>
          {showAllData ? leftData?.length + index + 1 : index + 1}.
        </Box>

        <Box className={styles4.acquisitorAnalyticBoxdetails}>
          <Box className={styles4.acquisitorAnalyticBoxdetailsImg}>
            {user?.avatar !== null ? (
              <Avatar
                src={
                  user?.avatar === "users/default.png"
                    ? NOprofileImage
                    : concatHostAndImagePath(user?.avatar)
                }
                width={52}
                height={52}
                alt=""
              />
            ) : (
              <Avatar
                src="/assets/images/memberProfileImg.png"
                width={52}
                height={52}
                alt=""
              />
            )}
          </Box>

          <Box className={styles4.acquisitorAnalyticBoxdetailsTxt}>
            {user.name && (
              <h4>
                {user.name ? `${user.name} ${user?.last_name ?? ""}` : ""}{" "}
                <span>
                  {buttonText === "Approved"
                    ? user?.videos_approved_count
                    : user?.videos_count}
                </span>
              </h4>
            )}
            {user?.role?.display_name && <p>{user?.role?.display_name}</p>}
          </Box>
        </Box>
      </Box>

      {/* <Dialog fullScreen
              open={open}
              onClose={handleClose}
              TransitionComponent={Transition} className='partnerSubmission'>
              <PartnerSubmissionFeeModal />
              <Button onClick={handleClose} className="closeBtn"><img src={assest.crossGray} width={13} height={13} alt="icon" /></Button>
          </Dialog> */}
      <EditorsLargeModal
        open={openNewEditorModal}
        onClose={handleCloseNewEditorModal}
      >
        {/* <PartnerSubmissionFeeModal accountSubmission={props.accountSubmission} classProps={props.classProps}/> */}

        {/******************** for partner page modal ********************/}
        {props.cardProp == "partner" ? (
          <Box
            className={`${styles1.partnerSubmissionModal} ${styles1.SubmissionModalPartner}`}
          >
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"flex-start"}
              flexWrap={"wrap"}
              className={`${styles.editorModalHeader} ${styles.editorModalPff}`}
            >
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                flexWrap={"wrap"}
                className={`${styles.PfMediaBody} ${styles1.PfMediaBodyPrtner} ${styles1.pertnerModal}`}
              >
                {/* <Avatar
                  alt="Viral Snare"
                  src={getAbsoluteImageURI(
                    props?.user?.avatar
                  )}
                  sx={{ width: 52, height: 52 }}
                /> */}
                {props?.user?.avatar === "users/default.png" ? (
                  <Avatar
                    alt="Viral Snare"
                    src={NOprofileImage}
                    sx={{ width: 52, height: 52 }}
                  />
                ) : (
                  <Avatar
                    alt="Viral Snare"
                    src={concatHostAndImagePath(props?.user?.avatar)}
                    sx={{ width: 52, height: 52 }}
                  />
                )}
                <Box
                  className={`${styles.profileMediaRight} ${styles1.profileMediaRightPartner}`}
                >
                  <Typography variant="body1">{`${props?.user?.name} ${props?.user?.last_name}`}</Typography>
                  <Typography variant="caption">Partner</Typography>
                </Box>
              </Stack>

              <Stack
                className={`${styles.tabsFlex} ${styles1.tabsFlexPartner} ${styles1.partnerTab}`}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    icon={
                      <span>
                        <HomeIcon />
                      </span>
                    }
                    iconPosition="start"
                    label="Home"
                    {...a11yProps(0)}
                  />
                  <Tab
                    icon={
                      <span>
                        <VideoIcon />
                      </span>
                    }
                    iconPosition="start"
                    label="Submissions"
                    {...a11yProps(0)}
                  />
                  <Tab
                    icon={
                      <span>
                        <AnalyticsIcon />
                      </span>
                    }
                    iconPosition="start"
                    label="Analytics"
                    {...a11yProps(1)}
                  />
                  <Tab
                    icon={
                      <span>
                        <ProfileIcon />
                      </span>
                    }
                    iconPosition="start"
                    label="Profile"
                    {...a11yProps(2)}
                  />
                </Tabs>
              </Stack>
            </Stack>

            <TabPanel value={value} index={0}>
              <Paper
                className={`${styles.tablePaper} ${styles1.tablePaperPartner}`}
              >
                <Box
                  className={`${styles.addEditor} ${styles.publishSummary} ${styles1.addEditorPartner}`}
                >
                  <Box className={styles1.monthYear}>
                    <Stack
                      direction={"row"}
                      flexWrap={"wrap"}
                      alignItems={"center"}
                      className={styles.viewDateStack}
                    >
                      <Typography variant="body1">View data for</Typography>
                      <Stack
                        direction={"row"}
                        flexWrap={"wrap"}
                        alignItems={"center"}
                        className={`${styles.showmonthyear} monthData`}
                      >
                        {/* <Typography variant="caption" className={styles.monthFor}>
                                                        Month
                                                    </Typography>
                                                    <Typography variant="caption" className={styles.yearFor}>
                                                        Year
                                                    </Typography> */}
                        <SelectMonth sendDataToParent={handleChildData} />
                        <SelectYear sendDataToParent={handleChildData} />
                      </Stack>
                    </Stack>
                  </Box>

                  <Box
                    className={`${styles1.videoDataBox} ${styles.videoDataBoxPartner}`}
                  >
                    <VideosummaryCardPartner
                      videoTitle="Submissions Summary"
                      countVideo={""}
                    >
                      <List>
                        <ListItem>
                          <Typography variant="body1">All videos</Typography>
                          <Typography variant="caption">
                            {submissions?.data?.data?.all_submissions?.total
                              ? submissions?.data?.data?.all_submissions?.total
                              : "-"}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Website-only videos
                          </Typography>
                          <Typography variant="caption">
                            {submissions?.data?.data?.all_submissions
                              ?.website_only
                              ? submissions?.data?.data?.all_submissions
                                  ?.website_only
                              : "-"}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            All-platform videos
                          </Typography>
                          <Typography variant="caption">
                            {submissions?.data?.data?.purchases_summary
                              ?.all_platform_videos
                              ? submissions?.data?.data?.purchases_summary
                                  ?.all_platform_videos
                              : "-"}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Duplicate videos
                          </Typography>
                          <Typography variant="caption">
                            {submissions?.data?.data?.all_submissions
                              ?.duplicate_videos
                              ? submissions?.data?.data?.all_submissions
                                  ?.duplicate_videos
                              : "-"}
                          </Typography>
                        </ListItem>
                      </List>
                    </VideosummaryCardPartner>
                    <img
                      src={assest.submissionSummeryImg}
                      width={56}
                      height={56}
                      alt=""
                    />
                  </Box>

                  {/* <Box className={`${styles1.videoDataBox} ${styles.videoDataBoxPartner}`}>
                          <VideosummaryCard videoTitle="Earnings" countVideo={''}>
                              <List>
                                  {earningLoop.map((item, index) => {
                                      return (
                                          <ListItem>
                                              <Typography variant='body1'>{item?.listName}</Typography>
                                              <Typography variant='caption'>{item?.videoCount}</Typography>
                                          </ListItem>
                                      );
                                  })}
                              </List>
                          </VideosummaryCard>
                          <img src={assest.earningImg} width={52} height={70} alt='' />
                      </Box> */}

                  <Box
                    className={`${styles1.videoDataBox} ${styles.videoDataBoxPartner}`}
                  >
                    <VideosummaryCardPartner
                      videoTitle="Earnings"
                      countVideo={""}
                    >
                      <List>
                        <ListItem>
                          <Typography variant="body1">
                            {props?.user?.payment_type &&
                            props?.user?.payment_type == 1
                              ? "Salary"
                              : "Submission fee"}
                          </Typography>
                          <Typography variant="caption">
                            {props?.user?.flat_rate
                              ? "$" + props?.user?.flat_rate
                              : props?.user?.rate_per_video
                              ? "$" + props?.user?.rate_per_video
                              : "-"}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Approved submissions
                          </Typography>
                          <Typography variant="caption">
                            {submissions?.data?.data?.all_submissions?.approved
                              ? "$" +
                                submissions?.data?.data?.all_submissions
                                  ?.approved
                              : "-"}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Total earnings
                          </Typography>
                          <Typography variant="caption">
                            {submissions?.data?.data?.earning?.total
                              ? "$" + submissions?.data?.data?.earning?.total
                              : "-"}
                          </Typography>
                        </ListItem>
                      </List>
                    </VideosummaryCardPartner>

                    <img
                      src={assest.chart_line}
                      width={52}
                      height={70}
                      alt=""
                    />
                  </Box>
                </Box>
              </Paper>
            </TabPanel>

            <TabPanel value={value} index={1}>
              <PartnerPageTable
                user_id={props?.user_id}
                videoCount={VideoSubmissions?.data?.data?.all_submissions}
              />
            </TabPanel>

            <TabPanel value={value} index={2}>
              <PerfectScrollbar>
                <Box className={styles1.analyticsWrapper}>
                  <Box className={styles1.analyticFull}>
                    <Box className={styles1.analyticLeft}>
                      <Box className={styles1.analyticBox}>
                        <Box
                          className={`${styles2.commonSmallBoxWrapper} ${styles1.analyticBoxItem}`}
                        >
                          <Box className="commonSmallBoxPartner">
                            <Box className={styles2.commonSmallBox}>
                              <Box className={styles2.infoTable}>
                                <Box className={styles2.infoTable_head}>
                                  <Link href="">
                                    <Box className={styles2.tble_hdng}>
                                      All Submissions
                                    </Box>
                                    <Box className={styles2.tble_hdng}>
                                      {VideoSubmissions?.data?.data
                                        ?.all_submissions?.total
                                        ? VideoSubmissions?.data?.data
                                            ?.all_submissions?.total
                                        : "-"}
                                    </Box>
                                  </Link>
                                </Box>

                                <Box className={styles2.infoTble_body}>
                                  <Box className={styles2.infoTble_row}>
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        Approved
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.all_submissions?.approved
                                          ? VideoSubmissions?.data?.data
                                              ?.all_submissions?.approved
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        Rejected
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.all_submissions?.rejected
                                          ? VideoSubmissions?.data?.data
                                              ?.all_submissions?.rejected
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        Website Only
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.all_submissions?.website_only
                                          ? VideoSubmissions?.data?.data
                                              ?.all_submissions?.website_only
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        Awaiting Confirmation
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.all_submissions
                                          ?.awaiting_confirmation
                                          ? VideoSubmissions?.data?.data
                                              ?.all_submissions
                                              ?.awaiting_confirmation
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        Duplicates
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.all_submissions?.duplicate
                                          ? VideoSubmissions?.data?.data
                                              ?.all_submissions?.duplicate
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box
                                    className={styles2.infoTble_row}
                                    // onClick={handleOpenSubmissionModal}
                                  >
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        Unreachable Submitters
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.all_submissions
                                          ?.unreachable_submitters
                                          ? VideoSubmissions?.data?.data
                                              ?.all_submissions
                                              ?.unreachable_submitters
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>

                      <Box className={styles1.analyticBox}>
                        <Box
                          className={`${styles2.commonSmallBoxWrapper} ${styles1.analyticBoxItem}`}
                        >
                          <Box className="commonSmallBoxPartner">
                            <Box className={styles2.commonSmallBox}>
                              <Box className={styles2.infoTable}>
                                <Box className={styles2.infoTable_head}>
                                  <Link href="">
                                    <Box className={styles2.tble_hdng}>
                                      Confirmed Videos
                                    </Box>
                                    <Box className={styles2.tble_hdng}>
                                      {VideoSubmissions?.data?.data
                                        ?.confirmed_videos?.total
                                        ? VideoSubmissions?.data?.data
                                            ?.confirmed_videos?.total
                                        : "-"}
                                    </Box>
                                  </Link>
                                </Box>

                                <Box className={styles2.infoTble_body}>
                                  <Box
                                    className={styles2.infoTble_row}
                                    // onClick={handleOpenApprovedModal}
                                  >
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Approved</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Approved</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.confirmed_videos?.approved_approved
                                          ? VideoSubmissions?.data?.data
                                              ?.confirmed_videos
                                              ?.approved_approved
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box
                                    className={styles2.infoTble_row}
                                    // onClick={handleOpenRejectedModal}
                                  >
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Rejected</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Rejected</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.confirmed_videos?.rejected_rejected
                                          ? VideoSubmissions?.data?.data
                                              ?.confirmed_videos
                                              ?.rejected_rejected
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box
                                    className={styles2.infoTble_row}
                                    // onClick={handleOpenWebsiteModal}
                                  >
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Website Only</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Website Only</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.confirmed_videos?.website_website
                                          ? VideoSubmissions?.data?.data
                                              ?.confirmed_videos
                                              ?.website_website
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>

                      <Box className={styles1.analyticBox}>
                        <Box
                          className={`${styles2.commonSmallBoxWrapper} ${styles1.analyticBoxItem}`}
                        >
                          <Box className="commonSmallBoxPartner">
                            <Box className={styles2.commonSmallBox}>
                              <Box className={styles2.infoTable}>
                                <Box className={styles2.infoTable_head}>
                                  <Link href="">
                                    <Box className={styles2.tble_hdng}>
                                      Denied Videos
                                    </Box>
                                    <Box className={styles2.tble_hdng}>
                                      {VideoSubmissions?.data?.data?.denied
                                        ?.total
                                        ? VideoSubmissions?.data?.data?.denied
                                            ?.total
                                        : "-"}
                                    </Box>
                                  </Link>
                                </Box>

                                <Box className={styles2.infoTble_body}>
                                  <Box
                                    className={styles2.infoTble_row}
                                    // onClick={handleOpenApproveRejectModal}
                                  >
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Approved</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Rejected</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data?.denied
                                          ?.approved_rejected
                                          ? VideoSubmissions?.data?.data?.denied
                                              ?.approved_rejected
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link
                                      href=""
                                      // onClick={handleOpenApproveWebsiteOnlyModal}
                                    >
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Approved</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Website Only</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data?.denied
                                          ?.approved_website
                                          ? VideoSubmissions?.data?.data?.denied
                                              ?.approved_website
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link
                                      href=""
                                      // onClick={handleOpenRejectedApproveModal}
                                    >
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Rejected</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Approved</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data?.denied
                                          ?.rejected_approved
                                          ? VideoSubmissions?.data?.data?.denied
                                              ?.rejected_approved
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link
                                      href=""
                                      // onClick={handleOpenRejectedWebModal}
                                    >
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Rejected</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Website Only</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data?.denied
                                          ?.rejected_website
                                          ? VideoSubmissions?.data?.data?.denied
                                              ?.rejected_website
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link
                                      href=""
                                      // onClick={handleOpenWebApprovedModal}
                                    >
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Website Only</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Approved</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data?.denied
                                          ?.website_approved
                                          ? VideoSubmissions?.data?.data?.denied
                                              ?.website_approved
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link
                                      href=""
                                      // onClick={handleOpenWebRejectedModal}
                                    >
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Website Only</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Rejected</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data?.denied
                                          ?.website_rejected
                                          ? VideoSubmissions?.data?.data?.denied
                                              ?.website_rejected
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>

                      <Box className={styles1.analyticBox}>
                        <Box
                          className={`${styles2.commonSmallBoxWrapper} ${styles1.analyticBoxItem}`}
                        >
                          <Box className="commonSmallBoxPartner commonSmallBoxAnalyticsBreakdown">
                            <AnalyticsBreakdown
                              earnings={earnings?.data?.earning}
                              setEarningSummaryYear={setEarningSummaryYear}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>

                    <Box className={styles1.analyticRight}>
                      <Box className={styles1.analyticRightBox}>
                        <Box className="commonSmallBoxPartner commonSmallBonusBox">
                          <Box className={styles1.bonusBox}>
                            <h4>Bonus</h4>

                            <Box className={styles1.bonusBoxInput}>
                              <label>Enter the bonus amount</label>
                              <input
                                type="text"
                                placeholder=""
                                {...register("amount")}
                              />
                              {errors?.amount ? (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "15px",
                                  }}
                                >
                                  {errors?.amount?.message}
                                </span>
                              ) : (
                                ""
                              )}

                              <Button
                                type="button"
                                onClick={handleClickOpenVideoBonus}
                              >
                                <span>Confirm </span> bonus
                              </Button>
                            </Box>
                          </Box>
                        </Box>
                      </Box>

                      <Box className={styles1.analyticRightBox}>
                        <Box className="commonSmallBoxPartner commonSmallBonusBoxlist">
                          <Box className={styles1.bonusBoxHistory}>
                            <Box className={styles1.bonusBoxHistory}>
                              <h4>Bonus History</h4>
                              <Button endIcon={<KeyboardArrowRightIcon />}>
                                See All
                              </Button>
                            </Box>
                          </Box>

                          {bonusData?.data?.bonus?.length ? (
                            <Box className={styles1.bonusBoxHistoryList}>
                              <PerfectScrollbar>
                                {bonusData?.data?.bonus?.map((item, index) => {
                                  return (
                                    <Box
                                      className={styles1.bonusBoxHistoryListBox}
                                      key={index}
                                    >
                                      <Box
                                        className={
                                          styles1.bonusBoxHistoryListBoxleft
                                        }
                                      >
                                        <h5>
                                          {getStyledShortDate(item?.created_at)}
                                        </h5>
                                        <p>
                                          {getStyledDateTime(item?.created_at)}
                                        </p>
                                      </Box>
                                      <Box
                                        className={
                                          styles1.bonusBoxHistoryListBoxRight
                                        }
                                      >
                                        <h5>
                                          {item?.bonus ? item?.bonus : "-"}
                                        </h5>
                                      </Box>
                                    </Box>
                                  );
                                })}
                              </PerfectScrollbar>
                            </Box>
                          ) : (
                            <Box className={styles1.paidBonus}>
                              <Box className={styles1.paidBonusTxt}>
                                <img
                                  src={assest.paidBonusIcon}
                                  width={32}
                                  height={26}
                                  alt=""
                                />
                                <p>Paid bonuses will be listed here.</p>
                              </Box>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </PerfectScrollbar>
            </TabPanel>

            <TabPanel value={value} index={3}>
              <Box className={styles1.profilePanel}>
                <ProfileTabPartner
                  user_id={props?.user_id}
                  resettext={"for_partners"}
                  accountSubmission={props.accountSubmission}
                  classProps={"true"}
                  classPropsPartner={"true"}
                  refetchPartnersList={props?.refetchPartnersList}
                  topAcqusitiorRefetch={topAcqusitiorRefetch}
                />
              </Box>
            </TabPanel>

            <ModalWrapperBonus
              open={openVideoBonus}
              onClose={handleCloseVideoBonus}
              handleClose={handleCloseVideoBonus}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <BonusModal
                bonusAmount={getValues()?.amount}
                bonusSnackOpen={bonusSnackOpen}
                handleCloseBonusSnack={setBonusSnackOpen}
                handleConfirmBonus={handleSubmit(handleConfirmBonus)}
                handleCloseVideoBonus={handleCloseVideoBonus}
              />
            </ModalWrapperBonus>
          </Box>
        ) : (
          <></>
        )}
        {/******************** for partner page modal ********************/}

        {/******************** for member page modal ********************/}
        {props.cardProp == "member" ? (
          <Box
            className={`${styles1.partnerSubmissionModal} ${styles1.SubmissionModalMember}`}
          >
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"flex-start"}
              flexWrap={"wrap"}
              className={`${styles.editorModalHeader} ${styles.editorModalPff} ${styles.editorModalPfff2}`}
            >
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                flexWrap={"wrap"}
                className={`${styles.PfMediaBody} ${styles1.PfMediaBodyPrtner}`}
              >
                {/* <Avatar
                  alt="Viral Snare"
                  src={getAbsoluteImageURI(
                    props?.user?.avatar
                  )}
                  sx={{ width: 52, height: 52 }}
                /> */}
                {props?.user?.avatar === "users/default.png" ? (
                  <Avatar
                    alt="Viral Snare"
                    src={NOprofileImage}
                    sx={{ width: 52, height: 52 }}
                  />
                ) : (
                  <Avatar
                    alt="Viral Snare"
                    src={concatHostAndImagePath(props?.user?.avatar)}
                    sx={{ width: 52, height: 52 }}
                  />
                )}
                <Box
                  className={`${styles.profileMediaRight} ${styles1.profileMediaRight}`}
                >
                  <Typography variant="body1">{`${props?.user?.name} ${props?.user?.last_name}`}</Typography>
                  <Typography variant="caption">Member</Typography>
                </Box>
              </Stack>

              <Stack
                className={`${styles.tabsFlex} ${styles1.tabsFlexPartner}`}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    icon={
                      <span>
                        <HomeIcon />
                      </span>
                    }
                    iconPosition="start"
                    label="Home"
                    {...a11yProps(0)}
                  />
                  <Tab
                    icon={
                      <span>
                        <VideoIcon />
                      </span>
                    }
                    iconPosition="start"
                    label="Submissions"
                    {...a11yProps(0)}
                  />
                  <Tab
                    icon={
                      <span>
                        <AnalyticsIcon />
                      </span>
                    }
                    iconPosition="start"
                    label="Analytics"
                    {...a11yProps(1)}
                  />
                  <Tab
                    icon={
                      <span>
                        <ProfileIcon />
                      </span>
                    }
                    iconPosition="start"
                    label="Profile"
                    {...a11yProps(2)}
                  />
                </Tabs>
              </Stack>
            </Stack>

            <TabPanel value={value} index={0}>
              <Paper
                className={`${styles.tablePaper} ${styles1.tablePaperPartner}`}
              >
                <Box
                  className={`${styles.addEditor} ${styles.publishSummary} ${styles1.addEditorPartner}`}
                >
                  <Box className={styles1.monthYear}>
                    <Stack
                      direction={"row"}
                      flexWrap={"wrap"}
                      alignItems={"center"}
                      className={styles.viewDateStack}
                    >
                      <Typography variant="body1">View data for</Typography>
                      <Stack
                        direction={"row"}
                        flexWrap={"wrap"}
                        alignItems={"center"}
                        className={`${styles.showmonthyear} monthData`}
                      >
                        {/* <Typography variant="caption" className={styles.monthFor}>
                                                        Month
                                                    </Typography>
                                                    <Typography variant="caption" className={styles.yearFor}>
                                                        Year
                                                    </Typography> */}
                        <SelectMonth sendDataToParent={handleChildData} />
                        <SelectYear sendDataToParent={handleChildData} />
                      </Stack>
                    </Stack>
                  </Box>

                  <Box
                    className={`${styles1.videoDataBox} ${styles.videoDataBoxPartner}`}
                  >
                    <VideosummaryCardPartner
                      videoTitle="Submissions Summary"
                      countVideo={""}
                    >
                      <List>
                        <ListItem>
                          <Typography variant="body1">All videos</Typography>
                          <Typography variant="caption">
                            {VideoSubmissions?.data?.data?.all_submissions
                              ?.total
                              ? VideoSubmissions?.data?.data?.all_submissions
                                  ?.total
                              : "-"}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Website-only videos
                          </Typography>
                          <Typography variant="caption">
                            {VideoSubmissions?.data?.data?.all_submissions
                              ?.website_only
                              ? VideoSubmissions?.data?.data?.all_submissions
                                  ?.website_only
                              : "-"}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            All-platform videos
                          </Typography>
                          <Typography variant="caption">
                            {VideoSubmissions?.data?.data?.purchases_summary
                              ?.all_platform_videos
                              ? VideoSubmissions?.data?.data?.purchases_summary
                                  ?.all_platform_videos
                              : "-"}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Duplicate videos
                          </Typography>
                          <Typography variant="caption">
                            {VideoSubmissions?.data?.data?.all_submissions
                              ?.duplicate_videos
                              ? VideoSubmissions?.data?.data?.all_submissions
                                  ?.duplicate_videos
                              : "-"}
                          </Typography>
                        </ListItem>
                      </List>
                    </VideosummaryCardPartner>
                    <img
                      src={assest.submissionSummeryImg}
                      width={56}
                      height={56}
                      alt=""
                    />
                  </Box>

                  {/* <Box className={`${styles1.videoDataBox} ${styles.videoDataBoxPartner}`}>
                                <VideosummaryCard videoTitle="Earnings" countVideo={''}>
                                    <List>
                                        {earningLoop.map((item, index) => {
                                            return (
                                                <ListItem>
                                                    <Typography variant='body1'>{item?.listName}</Typography>
                                                    <Typography variant='caption'>{item?.videoCount}</Typography>
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                </VideosummaryCard>
                                <img src={assest.earningImg} width={52} height={70} alt='' />
                            </Box> */}

                  <Box
                    className={`${styles1.videoDataBox} ${styles.videoDataBoxPartner}`}
                  >
                    <VideosummaryCardPartner
                      videoTitle="Earnings"
                      countVideo={""}
                    >
                      <List>
                        <ListItem>
                          <Typography variant="body1">
                            {props?.user?.payment_type &&
                            props?.user?.payment_type == 1
                              ? "Salary"
                              : "Submission fee"}
                          </Typography>
                          <Typography variant="caption">
                            {props?.user?.flat_rate
                              ? "$" + props?.user?.flat_rate
                              : props?.user?.rate_per_video
                              ? "$" + props?.user?.rate_per_video
                              : "-"}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Approved submissions
                          </Typography>
                          <Typography variant="caption">
                            {VideoSubmissions?.data?.data?.all_submissions
                              ?.approved
                              ? "$" +
                                VideoSubmissions?.data?.data?.all_submissions
                                  ?.approved
                              : "-"}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Total earnings
                          </Typography>
                          <Typography variant="caption">
                            {VideoSubmissions?.data?.data?.earning?.total
                              ? "$" +
                                VideoSubmissions?.data?.data?.earning?.total
                              : "-"}
                          </Typography>
                        </ListItem>
                      </List>
                    </VideosummaryCardPartner>
                    <img
                      src={assest.accountingIcon}
                      width={50}
                      height={56}
                      alt=""
                    />
                  </Box>
                </Box>
              </Paper>
            </TabPanel>

            <TabPanel value={value} index={1}>
              <MemberPageTable
                user_id={props?.user_id}
                videoCount={VideoSubmissions?.data?.data?.all_submissions}
              />
            </TabPanel>

            <TabPanel value={value} index={2}>
              <PerfectScrollbar>
                <Box className={styles1.analyticsWrapper}>
                  <Box className={styles1.analyticFull}>
                    <Box className={styles1.analyticLeft}>
                      <Box className={styles1.analyticBox}>
                        <Box
                          className={`${styles2.commonSmallBoxWrapper} ${styles1.analyticBoxItem}`}
                        >
                          <Box className="commonSmallBoxPartner">
                            <Box className={styles2.commonSmallBox}>
                              <Box className={styles2.infoTable}>
                                <Box className={styles2.infoTable_head}>
                                  <Link href="">
                                    <Box className={styles2.tble_hdng}>
                                      All Submissions
                                    </Box>
                                    <Box className={styles2.tble_hdng}>
                                      {VideoSubmissions?.data?.data
                                        ?.all_submissions?.total
                                        ? VideoSubmissions?.data?.data
                                            ?.all_submissions?.total
                                        : "-"}
                                    </Box>
                                  </Link>
                                </Box>

                                <Box className={styles2.infoTble_body}>
                                  <Box className={styles2.infoTble_row}>
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        Approved
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.all_submissions?.approved
                                          ? VideoSubmissions?.data?.data
                                              ?.all_submissions?.approved
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        Rejected
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.all_submissions?.rejected
                                          ? VideoSubmissions?.data?.data
                                              ?.all_submissions?.rejected
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        Website Only
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.all_submissions?.website_only
                                          ? VideoSubmissions?.data?.data
                                              ?.all_submissions?.website_only
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        Awaiting Confirmation
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.all_submissions
                                          ?.awaiting_confirmation
                                          ? VideoSubmissions?.data?.data
                                              ?.all_submissions
                                              ?.awaiting_confirmation
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        Duplicates
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.all_submissions?.duplicate_videos
                                          ? VideoSubmissions?.data?.data
                                              ?.all_submissions
                                              ?.duplicate_videos
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box
                                    className={styles2.infoTble_row}
                                    // onClick={handleOpenSubmissionModal}
                                  >
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        Unreachable Submitters
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.all_submissions
                                          ?.unreachable_submitters
                                          ? VideoSubmissions?.data?.data
                                              ?.all_submissions
                                              ?.unreachable_submitters
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>

                      <Box className={styles1.analyticBox}>
                        <Box
                          className={`${styles2.commonSmallBoxWrapper} ${styles1.analyticBoxItem}`}
                        >
                          <Box className="commonSmallBoxPartner">
                            <Box className={styles2.commonSmallBox}>
                              <Box className={styles2.infoTable}>
                                <Box className={styles2.infoTable_head}>
                                  <Link href="">
                                    <Box className={styles2.tble_hdng}>
                                      Confirmed Videos
                                    </Box>
                                    <Box className={styles2.tble_hdng}>
                                      {VideoSubmissions?.data?.data
                                        ?.confirmed_videos?.total
                                        ? VideoSubmissions?.data?.data
                                            ?.confirmed_videos?.total
                                        : "-"}
                                    </Box>
                                  </Link>
                                </Box>

                                <Box className={styles2.infoTble_body}>
                                  <Box
                                    className={styles2.infoTble_row}
                                    // onClick={handleOpenApprovedModal}
                                  >
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Approved</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Approved</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.confirmed_videos?.approved_approved
                                          ? VideoSubmissions?.data?.data
                                              ?.confirmed_videos
                                              ?.approved_approved
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box
                                    className={styles2.infoTble_row}
                                    // onClick={handleOpenRejectedModal}
                                  >
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Rejected</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Rejected</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.confirmed_videos?.rejected_rejected
                                          ? VideoSubmissions?.data?.data
                                              ?.confirmed_videos
                                              ?.rejected_rejected
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box
                                    className={styles2.infoTble_row}
                                    // onClick={handleOpenWebsiteModal}
                                  >
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Website Only</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Website Only</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data
                                          ?.confirmed_videos?.website_website
                                          ? VideoSubmissions?.data?.data
                                              ?.confirmed_videos
                                              ?.website_website
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>

                      <Box className={styles1.analyticBox}>
                        <Box
                          className={`${styles2.commonSmallBoxWrapper} ${styles1.analyticBoxItem}`}
                        >
                          <Box className="commonSmallBoxPartner">
                            <Box className={styles2.commonSmallBox}>
                              <Box className={styles2.infoTable}>
                                <Box className={styles2.infoTable_head}>
                                  <Link href="">
                                    <Box className={styles2.tble_hdng}>
                                      Denied Videos
                                    </Box>
                                    <Box className={styles2.tble_hdng}>
                                      {VideoSubmissions?.data?.data?.denied
                                        ?.total
                                        ? VideoSubmissions?.data?.data?.denied
                                            ?.total
                                        : "-"}
                                    </Box>
                                  </Link>
                                </Box>

                                <Box className={styles2.infoTble_body}>
                                  <Box
                                    className={styles2.infoTble_row}
                                    // onClick={handleOpenApproveRejectModal}
                                  >
                                    <Link href="">
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Approved</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Rejected</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data?.denied
                                          ?.approved_rejected
                                          ? VideoSubmissions?.data?.data?.denied
                                              ?.approved_rejected
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link
                                      href=""
                                      // onClick={handleOpenApproveWebsiteOnlyModal}
                                    >
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Approved</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Website Only</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data?.denied
                                          ?.approved_website
                                          ? VideoSubmissions?.data?.data?.denied
                                              ?.approved_website
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link
                                      href=""
                                      // onClick={handleOpenRejectedApproveModal}
                                    >
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Rejected</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Approved</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data?.denied
                                          ?.rejected_approved
                                          ? VideoSubmissions?.data?.data?.denied
                                              ?.rejected_approved
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link
                                      href=""
                                      // onClick={handleOpenRejectedWebModal}
                                    >
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Rejected</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Website Only</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data?.denied
                                          ?.rejected_website
                                          ? VideoSubmissions?.data?.data?.denied
                                              ?.rejected_website
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link
                                      href=""
                                      // onClick={handleOpenWebApprovedModal}
                                    >
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Website Only</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Approved</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data?.denied
                                          ?.website_approved
                                          ? VideoSubmissions?.data?.data?.denied
                                              ?.website_approved
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                  <Box className={styles2.infoTble_row}>
                                    <Link
                                      href=""
                                      // onClick={handleOpenWebRejectedModal}
                                    >
                                      <Box className={styles2.infoTble_cell}>
                                        <Box className={styles2.tble_innrWrp}>
                                          <span>Website Only</span>
                                          <img
                                            src={assest.arrowIcon}
                                            width={53}
                                            height={3}
                                            alt=""
                                          />
                                          <span>Rejected</span>
                                        </Box>
                                      </Box>
                                      <Box className={styles2.infoTble_cell}>
                                        {VideoSubmissions?.data?.data?.denied
                                          ?.website_rejected
                                          ? VideoSubmissions?.data?.data?.denied
                                              ?.website_rejected
                                          : "-"}
                                      </Box>
                                    </Link>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>

                      <Box className={styles1.analyticBox}>
                        <Box
                          className={`${styles2.commonSmallBoxWrapper} ${styles1.analyticBoxItem}`}
                        >
                          <Box className="commonSmallBoxPartner commonSmallBoxAnalyticsBreakdown">
                            <AnalyticsBreakdown
                              earnings={earnings?.data?.earning}
                              setEarningSummaryYear={setEarningSummaryYear}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>

                    <Box className={styles1.analyticRight}>
                      <Box className={styles1.analyticRightBox}>
                        <Box className="commonSmallBoxPartner commonSmallBonusBox">
                          <Box className={styles1.bonusBox}>
                            <h4>Bonus</h4>

                            <Box className={styles1.bonusBoxInput}>
                              <label>Enter the bonus amount</label>
                              <input
                                type="text"
                                placeholder=""
                                {...register("amount")}
                              />
                              {errors?.amount ? (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "15px",
                                  }}
                                >
                                  {errors?.amount?.message}
                                </span>
                              ) : (
                                ""
                              )}

                              <Button
                                type="button"
                                onClick={handleClickOpenVideoBonus}
                              >
                                <span>Confirm </span> bonus
                              </Button>
                            </Box>
                          </Box>
                        </Box>
                      </Box>

                      <Box className={styles1.analyticRightBox}>
                        <Box className="commonSmallBoxPartner commonSmallBonusBoxlist">
                          <Box className={styles1.bonusBoxHistory}>
                            <Box className={styles1.bonusBoxHistory}>
                              <h4>Bonus History</h4>
                              <Button endIcon={<KeyboardArrowRightIcon />}>
                                See All
                              </Button>
                            </Box>
                          </Box>

                          {bonusData?.data?.bonus?.length > 0 ? (
                            <Box className={styles1.bonusBoxHistoryList}>
                              <PerfectScrollbar>
                                {bonusData?.data?.bonus?.map((item, index) => {
                                  return (
                                    <Box
                                      className={styles1.bonusBoxHistoryListBox}
                                      key={index}
                                    >
                                      <Box
                                        className={
                                          styles1.bonusBoxHistoryListBoxleft
                                        }
                                      >
                                        <h5>
                                          {" "}
                                          {getStyledShortDate(item?.created_at)}
                                        </h5>
                                        <p>
                                          {getUtcDateTime(item?.created_at)}
                                        </p>
                                      </Box>
                                      <Box
                                        className={
                                          styles1.bonusBoxHistoryListBoxRight
                                        }
                                      >
                                        <h5>
                                          $
                                          {item?.bonus === null
                                            ? 0
                                            : item?.bonus}
                                        </h5>
                                      </Box>
                                    </Box>
                                  );
                                })}
                              </PerfectScrollbar>
                            </Box>
                          ) : (
                            <Box className={styles1.paidBonus}>
                              <Box className={styles1.paidBonusTxt}>
                                <img
                                  src={assest.paidBonusIcon}
                                  width={32}
                                  height={26}
                                  alt=""
                                />
                                <p>Paid bonuses will be listed here.</p>
                              </Box>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </PerfectScrollbar>
            </TabPanel>

            <TabPanel value={value} index={3}>
              <Box className={styles1.profilePanel}>
                <ProfileTabMember
                  user_id={props?.user_id}
                  resettext={"for_partners"}
                  accountSubmission={props.accountSubmission}
                  classProps={"true"}
                  classPropsPartner={"true"}
                  refetchMembersList={props?.refetchMembersList}
                  topAcqusitiorRefetch={topAcqusitiorRefetch}
                />
              </Box>
            </TabPanel>

            <ModalWrapperBonus
              open={openVideoBonus}
              onClose={handleCloseVideoBonus}
              handleClose={handleCloseVideoBonus}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <BonusModal
                bonusAmount={getValues()?.amount}
                bonusSnackOpen={bonusSnackOpen}
                handleCloseBonusSnack={setBonusSnackOpen}
                handleConfirmBonus={handleSubmit(handleConfirmBonus)}
                handleCloseVideoBonus={handleCloseVideoBonus}
              />
            </ModalWrapperBonus>
          </Box>
        ) : (
          <></>
        )}
        {/******************** for member page modal ********************/}

        {/******************** for buyerlist page modal ********************/}
        {props.cardProp == "buyerList" ? (
          <Box
            className={`${styles1.partnerSubmissionModal} ${styles1.SubmissionModalBuyerList}`}
          >
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"flex-start"}
              flexWrap={"wrap"}
              className={styles.editorModalHeader}
            >
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                flexWrap={"wrap"}
                className={`${styles.PfMediaBody} ${styles1.PfMediaBodyPrtner}`}
              >
                {props?.image === "users/default.png" ? (
                  <Avatar
                    alt="Viral Snare"
                    src={NOprofileImage}
                    sx={{ width: 52, height: 52 }}
                  />
                ) : (
                  <Avatar
                    alt="Viral Snare"
                    src={concatHostAndImagePath(props?.image)}
                    sx={{ width: 52, height: 52 }}
                  />
                )}
                <Box className={styles.profileMediaRight}>
                  <Typography variant="body1">{props.cardName}</Typography>
                  <Typography variant="caption">Content Buyer</Typography>
                </Box>
              </Stack>
              <Stack
                className={`${styles.tabsFlex} ${styles1.tabsFlexPartner}`}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    icon={
                      <span>
                        <HomeIcon />
                      </span>
                    }
                    iconPosition="start"
                    label="Home"
                    {...a11yProps(0)}
                  />
                  <Tab
                    icon={
                      <span>
                        <VideoIcon />
                      </span>
                    }
                    iconPosition="start"
                    label="Submissions"
                    {...a11yProps(0)}
                  />
                  <Tab
                    icon={
                      <span>
                        <AnalyticsIcon />
                      </span>
                    }
                    iconPosition="start"
                    label="Analytics"
                    {...a11yProps(1)}
                  />
                  <Tab
                    icon={
                      <span>
                        <ProfileIcon />
                      </span>
                    }
                    iconPosition="start"
                    label="Profile"
                    {...a11yProps(2)}
                  />
                  <Tab
                    icon={
                      <span>
                        <AccountingIcon />
                      </span>
                    }
                    iconPosition="start"
                    label="Accounting"
                    {...a11yProps(3)}
                  />
                </Tabs>
              </Stack>
            </Stack>

            <TabPanel value={value} index={0}>
              <Paper
                className={`${styles.tablePaper} ${styles1.tablePaperPartner}`}
              >
                <Box
                  className={`${styles.addEditor} ${styles.publishSummary} ${styles1.addEditorPartner}`}
                >
                  <Box className={styles1.monthYear}>
                    <Stack
                      direction={"row"}
                      flexWrap={"wrap"}
                      alignItems={"center"}
                      className={styles.viewDateStack}
                    >
                      <Typography variant="body1">View data for</Typography>
                      <Stack
                        direction={"row"}
                        flexWrap={"wrap"}
                        alignItems={"center"}
                        className={`${styles.showmonthyear} monthData`}
                      >
                        {/* <Typography variant="caption" className={styles.monthFor}>
                        Month
                      </Typography>
                      <Typography variant="caption" className={styles.yearFor}>
                        Year
                      </Typography> */}
                        <SelectMonth sendDataToParent={handleChildData} />
                        <SelectYear sendDataToParent={handleChildData} />
                      </Stack>
                    </Stack>
                  </Box>

                  <Box
                    className={`${styles1.videoDataBox} ${styles.videoDataBoxPartner}`}
                  >
                    <VideosummaryCardPartner
                      videoTitle="Purchases Summary"
                      countVideo={""}
                    >
                      <List className={styles.buyerListvdocard}>
                        <ListItem>
                          <Typography variant="body1">All videos</Typography>
                          <Typography variant="caption">
                            {
                              contentBuyerSubmissions?.data?.data
                                ?.purchases_summary?.all_videos
                            }
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Website-only videos
                          </Typography>
                          <Typography variant="caption">
                            {
                              contentBuyerSubmissions?.data?.data
                                ?.purchases_summary?.website_only_videos
                            }
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            All-platform videos
                          </Typography>
                          <Typography variant="caption">
                            {
                              contentBuyerSubmissions?.data?.data
                                ?.purchases_summary?.all_platform_videos
                            }
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Duplicate videos
                          </Typography>
                          <Typography variant="caption">
                            {
                              contentBuyerSubmissions?.data?.data
                                ?.all_submissions?.duplicate_videos
                            }
                          </Typography>
                        </ListItem>
                      </List>
                    </VideosummaryCardPartner>
                    <img
                      src={assest.submissionSummeryImg}
                      width={56}
                      height={56}
                      alt=""
                    />
                  </Box>

                  {/* <Box className={`${styles1.videoDataBox} ${styles.videoDataBoxPartner}`}>
                                <VideosummaryCard videoTitle="Earnings" countVideo={''}>
                                    <List>
                                        {earningLoop.map((item, index) => {
                                            return (
                                                <ListItem>
                                                    <Typography variant='body1'>{item?.listName}</Typography>
                                                    <Typography variant='caption'>{item?.videoCount}</Typography>
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                </VideosummaryCard>
                                <img src={assest.earningImg} width={52} height={70} alt='' />
                            </Box> */}

                  <Box
                    className={`${styles1.videoDataBox} ${styles.videoDataBoxPartner}`}
                  >
                    <VideosummaryCardPartner
                      videoTitle="Accounting"
                      countVideo={""}
                    >
                      <List className={styles.buyerListvdocard}>
                        <ListItem>
                          <Typography variant="body1">
                            Total purchases
                          </Typography>
                          <Typography variant="caption">
                            $
                            {
                              contentBuyerSubmissions?.data?.data?.accounting
                                ?.total_purchase
                            }
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Total commission
                          </Typography>
                          <Typography variant="caption">
                            {
                              contentBuyerSubmissions?.data?.data?.accounting
                                ?.total_commission
                            }
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Outstanding balance
                          </Typography>
                          <Typography variant="caption">
                            ${" "}
                            {
                              contentBuyerSubmissions?.data?.data?.accounting
                                ?.outstading_balance
                            }
                          </Typography>
                        </ListItem>
                      </List>
                    </VideosummaryCardPartner>
                    <img
                      src={assest.accountingIcon}
                      width={50}
                      height={56}
                      alt=""
                    />
                  </Box>
                </Box>
              </Paper>
            </TabPanel>

            <TabPanel value={value} index={1}>
              <BuyerPageTable
                buyer_id={props?.user_id}
                contentBuyerSubmissions={contentBuyerSubmissions}
              />
            </TabPanel>

            <TabPanel value={value} index={2}>
              {/* <PerfectScrollbar> */}
              <Box className={styles1.analyticsWrapper}>
                <Box className={styles1.BuyerListanalyticFull}>
                  <Box
                    className={`${styles1.BuyerListanalyticLeft} ${styles1.buyerListLeft}`}
                  >
                    <Box
                      className={`${styles2.commonSmallBoxWrapper} ${styles1.BuyerListBox}`}
                    >
                      <Box
                        className={`commonSmallBoxPartner commonSmallBoxPartnerChart ${styles1.buyerListalaytics}`}
                      >
                        <Box className={styles1.analyticChartBox}>
                          <Box className={styles1.chartBoxWrapper}>
                            <Box className={styles1.chartBoxWrapperHeader}>
                              <h4>Purchases Breakdown</h4>
                              <CustomSelectTwo
                                value={year}
                                onChange={handleChangeYear}
                                displayEmpty
                              >
                                <MenuItem value={""}></MenuItem>
                                {yearList.map((_y) => (
                                  <MenuItem key={_y} value={_y}>
                                    {_y == new Date().getFullYear()
                                      ? "This year"
                                      : _y}
                                    {/* {_y} */}
                                  </MenuItem>
                                ))}
                              </CustomSelectTwo>
                            </Box>
                            <Box className="chartBlackWhite">
                              <ContentBuyerGraph
                                data={contentBuyerGraphData?.data}
                                loading={contentBuyerGraphLoading}
                              />
                            </Box>
                          </Box>

                          <Box className={styles1.chartCategoriesList}>
                            <List>
                              <ListItem>
                                <Box className={styles1.chartCategories}>
                                  <Box className={styles1.chartCategoriesIcon}>
                                    <img
                                      src={assest.allSubmissionChartImg}
                                      width={54}
                                      height={54}
                                      alt=""
                                    />
                                  </Box>
                                  <Box className={styles1.chartCategoriesTxt}>
                                    <p>All Submissions</p>
                                    <p>
                                      <strong>
                                        {
                                          contentBuyerSubmissions?.data?.data
                                            ?.validate_summary?.all_submissions
                                        }
                                      </strong>
                                    </p>
                                  </Box>
                                </Box>
                              </ListItem>
                              <ListItem>
                                <Box className={styles1.chartCategories}>
                                  <Box className={styles1.chartCategoriesIcon}>
                                    <img
                                      src={assest.allPlatfromChartImg}
                                      width={54}
                                      height={54}
                                      alt=""
                                    />
                                  </Box>
                                  <Box className={styles1.chartCategoriesTxt}>
                                    <p>All-platform</p>
                                    <p>
                                      {
                                        contentBuyerSubmissions?.data?.data
                                          ?.all_submissions?.approved
                                      }
                                    </p>
                                  </Box>
                                </Box>
                              </ListItem>
                              <ListItem>
                                <Box className={styles1.chartCategories}>
                                  <Box className={styles1.chartCategoriesIcon}>
                                    <img
                                      src={assest.websiteonlyChartImg}
                                      width={54}
                                      height={54}
                                      alt=""
                                    />
                                  </Box>
                                  <Box className={styles1.chartCategoriesTxt}>
                                    <p>Website-Only</p>
                                    <p>
                                      {
                                        contentBuyerSubmissions?.data?.data
                                          ?.all_submissions?.website_only
                                      }
                                    </p>
                                  </Box>
                                </Box>
                              </ListItem>
                            </List>
                          </Box>
                        </Box>
                      </Box>
                    </Box>

                    <Box
                      className={`${styles2.commonSmallBoxWrapper} ${styles1.BuyerListBox}`}
                    >
                      <Box className="commonSmallBoxPartner commonSmallBoxAnalyticsBreakdown">
                        <ContentBuyerAnalyticsBreakdown
                          buyer_id={props?.user_id}
                          name={props?.cardName}
                        />
                      </Box>
                    </Box>
                  </Box>

                  <Box
                    className={`${styles1.BuyerListanalyticRight} ${styles1.buyerListLeft}`}
                  >
                    <Box
                      className={`commonSmallBoxPartner commonSmallBonusBox ${styles1.buyerBonus}`}
                    >
                      <Box className={styles1.bonusBox}>
                        <h4>Bonus</h4>

                        <Box className={styles1.bonusBoxInput}>
                          <label>Enter the bonus amount</label>
                          <input
                            type="text"
                            placeholder=""
                            {...register("amount")}
                          />
                          {errors?.amount ? (
                            <span
                              style={{
                                color: "red",
                                fontSize: "15px",
                              }}
                            >
                              {errors?.amount?.message}
                            </span>
                          ) : (
                            ""
                          )}

                          <Button
                            type="button"
                            onClick={handleSubmit(handleConfirmBonus)}
                          >
                            <span>Confirm </span> bonus
                          </Button>
                        </Box>
                      </Box>
                    </Box>

                    <Box
                      className={`commonSmallBoxPartner commonSmallBonusBoxlist ${styles.buyerlistAnalyticsBonus}`}
                    >
                      <Box className={styles1.bonusBoxHistory}>
                        <Box className={styles1.bonusBoxHistory}>
                          <h4>Bonus History</h4>
                          <Button
                            endIcon={<KeyboardArrowRightIcon />}
                            onClick={handleClickOpenLargeOpacity}
                          >
                            See All
                          </Button>
                        </Box>
                      </Box>
                      {bonusData?.data?.bonus?.length > 0 ? (
                        <Box className={styles1.bonusBoxHistoryList}>
                          <PerfectScrollbar>
                            {bonusData?.data?.bonus?.map((item, index) => {
                              return (
                                <Box
                                  className={styles1.bonusBoxHistoryListBox}
                                  key={index}
                                >
                                  <Box
                                    className={
                                      styles1.bonusBoxHistoryListBoxleft
                                    }
                                  >
                                    <h5>
                                      {" "}
                                      {getStyledShortDate(item?.created_at)}
                                    </h5>
                                    <p>{getUtcDateTime(item?.created_at)}</p>
                                  </Box>
                                  <Box
                                    className={
                                      styles1.bonusBoxHistoryListBoxRight
                                    }
                                  >
                                    <h5>
                                      ${item?.bonus === null ? 0 : item?.bonus}
                                    </h5>
                                  </Box>
                                </Box>
                              );
                            })}
                          </PerfectScrollbar>
                        </Box>
                      ) : (
                        <Box className={styles1.paidBonus}>
                          <Box className={styles1.paidBonusTxt}>
                            <img
                              src={assest.paidBonusIcon}
                              width={32}
                              height={26}
                              alt=""
                            />
                            <p>Paid bonuses will be listed here.</p>
                          </Box>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>
              {/* </PerfectScrollbar> */}
            </TabPanel>

            <TabPanel value={value} index={3}>
              <Box className={styles1.profilePanel}>
                <ProfileTabBuyerList
                  user_id={props?.user_id}
                  userData={props?.totalData}
                  resettext={"for_buyer"}
                  accountSubmission={props.accountSubmission}
                  classProps={"true"}
                  classPropsPartner={"true"}
                />
              </Box>
            </TabPanel>

            <TabPanel value={value} index={4}>
              <BuyerAccounting
                contentBuyerSubmissions={contentBuyerSubmissions}
                contentBuyerSubmissionsRefetch={contentBuyerSubmissionsRefetch}
                user_id={props?.user_id}
              />
            </TabPanel>

            <ModalWrapperBonus
              open={openVideoBonus}
              onClose={handleCloseVideoBonus}
              handleClose={handleCloseVideoBonus}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <BonusModal handleCloseVideoBonus={handleCloseVideoBonus} />
            </ModalWrapperBonus>
          </Box>
        ) : (
          <></>
        )}
        {/******************** for buyerlist page modal ********************/}
        <ModalWrappperLargeOpacity
          open={openLargeOpacity}
          onClose={handleCloseLargeOpacity}
          handleClose={handleCloseLargeOpacity}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className={styles.bonusHistoryWrapper}>
            {bonusData?.data?.bonus?.length > 0 ? (
              <Box className={styles1.bonusBoxHistoryList}>
                <PerfectScrollbar>
                  {bonusData?.data?.bonus?.map((item, index) => {
                    return (
                      <>
                        <Box
                          className={styles1.bonusBoxHistoryListBox}
                          key={index}
                        >
                          <Box className={styles1.bonusBoxHistoryListBoxleft}>
                            <h5
                              style={{
                                color: "#111AE9",
                              }}
                            >
                              {" "}
                              {getStyledShortDate(item?.created_at)}
                            </h5>
                            <p>{getUtcDateTime(item?.created_at)}</p>
                          </Box>
                          <Box className={styles1.bonusBoxHistoryListBoxRight}>
                            <h5>${item?.bonus === null ? 0 : item?.bonus}</h5>
                          </Box>
                        </Box>
                      </>
                    );
                  })}
                </PerfectScrollbar>
              </Box>
            ) : (
              <Box className={styles1.paidBonus}>
                <Box className={styles1.paidBonusTxt}>
                  <img
                    src={assest.paidBonusIcon}
                    width={32}
                    height={26}
                    alt=""
                  />
                  <p>Paid bonuses will be listed here.</p>
                </Box>
              </Box>
            )}
          </Box>
        </ModalWrappperLargeOpacity>

        <Button onClick={handleCloseNewEditorModal} className="partnerCloseBtn">
          <img src={assest.crossGray} width={13} height={13} alt="icon" />
        </Button>
      </EditorsLargeModal>
    </>
  );
};

export default TopAccusitorPartnerCard;
